export default {
  name: 'marking--printLoad',
  apiService: 'shoes',
  apiPath: '/admin/print/func/load',
  urlParamName: 'marking--printLoad',
};